import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    bg: 'base',
    minH: 'unset',
    color: 'white',
    fontSize: 'xs',
    borderRadius: 'full',
    h: 4,
  },
});

export const Tag = defineMultiStyleConfig({ baseStyle });
